import $ from 'jquery'
import {} from 'jquery-validation'
import {} from 'bootstrap'
import WOW from 'wow.js'
import {} from 'cardslider'
import {} from 'slick-carousel'
import debounce from 'lodash/debounce'

import Turbolinks from 'turbolinks'
import Rails from '@rails/ujs'

window.$ = $
window.jQuery = $
window.WOW = WOW

Rails.start()

Turbolinks.start()

function handleServerError() {
  const serverErrors = document.getElementsByClassName('invalid-feedback')

  for (const element of serverErrors) {
    const parentNode = element.parentNode
    const errorPlaceholder = $(parentNode).find('.error-placeholder')
    errorPlaceholder && errorPlaceholder.remove()
    const frontendError = $(parentNode).find('.invalid-feedback .error')
    frontendError && frontendError.remove()
  }
}

function adjustPageHeight() {
  // adjust main and .page element heights to compensate for .overlay-section movements
  // only do it on the homepage though
  if (window.location.pathname === '/' || window.location.pathname === '/home') {
    const footer = $('footer')
    if (!footer.length) {
      return
    }
    const footerOffset = footer.offset()
    if (!footerOffset) {
      return
    }
    let footerTop = footerOffset.top + $('body').scrollTop()
    let footerHeight = footer.outerHeight()
    $('main').outerHeight(footerTop)
    $('.page').outerHeight(footerTop + footerHeight)
  }
}

// signup form on homepage functions
function addParticipantField() {
  // eslint-disable-next-line max-len
  const participantInput = '<div style="display:none;" class="form-label-group input-group email optional signup_participants"><input class="form-control base string optional mt-2" placeholder="client@email.com" type="email" name="signup[participants][]" id="signup_participants"><label class="form-control-label email optional" for="signup_participants">Add People</label></div>'
  if ($('#email_list .signup_participants').last().find('input').val() !== '') {
    $('#email_list').append($(participantInput).fadeIn())
  }
  $('#email_list .signup_participants').last().find('input').trigger('focus')
}

function showValidIcon(currentEl) {
  const validInputGroup = currentEl.parent('.form-group-valid')
  const icon = $('.valid-icon')
  if (!(validInputGroup.find(icon).length)) {
    validInputGroup.prepend(icon.first().clone().show())
  }
}

function handleFormUpdate(currentEl) {
  showValidIcon(currentEl)
  addParticipantField()

  if ($('#email_list .signup_participants').length === 1) {
    // update section title
    $('.quick-sign-up h1 span').first().removeClass('active')
    $('.create-workspace .text-animation span').addClass('active')
    //update form title
    $('#form-title').text('Add Other People')
    // show submit button
    $('.form-btn-container').fadeIn()
    // add 'first' class for arrow positioning
    $('#email_list .signup_participants').first().addClass('first')
  }
}

function ready() {
  handleServerError()

  // The page is visible without JavaScript; enhance its measured layout once
  // the primary bundle is available.
  adjustPageHeight()

  // mobile menu button
  $('.menu-icon').on('click', function() {
    $('body').toggleClass('open-menu')
  })

  // shrink header on scroll
  function scrolledHeader() {
    var scroll = $('body').scrollTop()
    if (scroll > 80) {
      $('.header').addClass('scrolled')
    } else {
      $('.header').removeClass('scrolled')
    }
  }
  $('body').on('scroll', debounce(scrolledHeader, 100))

  // init animate on scroll
  var wow = new WOW({
    offset: 1,
    mobile: true,
    live: false,
    scrollContainer: 'body'
  })
  wow.init()

  // index slider
  function setActiveTextSpan(className) {
    const span = $('.text-animation .' + className)
    if (!span.length) {
      return
    }
    $('.text-animation .is-visible').addClass('was-visible').removeClass('is-visible')
    span.removeClass('was-visible').addClass('is-visible')
  }

  if ($('.my-slider').length) {
    const navClasses = ['nav-chat', 'nav-calls', 'nav-meetings', 'nav-projects', 'nav-platforms']
    const textClasses = ['text1', 'text2', 'text3', 'text4', 'text5']
    const sliderIntervalMs = 11000
    const $slider = $('.my-slider ul').length ? $('.my-slider ul') : $('.my-slider')

    let progressBarInterval
    function updateProgressBar(selector) {
      let timeleft = 0
      clearInterval(progressBarInterval)
      progressBarInterval = setInterval(function() {
        if (timeleft >= 100) {
          clearInterval(progressBarInterval)
        }
        $(selector).css('width', timeleft + '%')
        timeleft += 1
      }, 100)
    }

    function activateIndex(index) {
      $('.slider-nav .item').removeClass('active')
      $('.slider-nav .' + navClasses[index]).addClass('active')
      $('.line-value').css('width', '0%')
      updateProgressBar('.' + navClasses[index] + ' .line-value')
      setActiveTextSpan(textClasses[index])
    }

    let count = 0
    let transitionInterval
    let cardsliderInstance = null

    function startTransitions() {
      transition()
      clearInterval(transitionInterval)
      transitionInterval = setInterval(transition, sliderIntervalMs)
    }

    if ($.fn.cardslider) {
      try {
        cardsliderInstance = $slider.cardslider({ swipe: true, dots: false, direction: 'left' }).data('cardslider')
      } catch (error) {
        cardsliderInstance = null
      }
    }
    if (!cardsliderInstance && $.fn.slick) {
      $slider.slick({
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: false,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
      })
    }

    function transition() {
      activateIndex(count)
      if (cardsliderInstance) {
        cardsliderInstance.changeCardTo(count)
      } else if ($.fn.slick) {
        $slider.slick('slickGoTo', count, true)
      }
      count = (count + 1) % navClasses.length
    }

    startTransitions()

    navClasses.forEach(function(navClass, index) {
      $('.slider-nav .' + navClass).on('click', function() {
        count = (index + 1) % navClasses.length
        activateIndex(index)
        if (cardsliderInstance) {
          cardsliderInstance.changeCardTo(index)
        } else if ($.fn.slick) {
          $slider.slick('slickGoTo', index, true)
        }
        startTransitions()
      })
    })
  }

  // features slider
  if ($('.slider').length) {
    $('.slider').slick({
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: false,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
    })

    $('.slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $('.progressBarContainer .item').removeClass('active')
      $('.progressBarContainer .item' + nextSlide).addClass('active')
    })

    //ticking machine
    var percentTime
    var tick
    var time = .1
    var progressBarIndex = 0

    $('.progressBarContainer .progressBar').each(function(index) {
      var progress = "<div class='inProgress inProgress" + index + "'></div>"
      $(this).html(progress)
    })

    function startProgressbar() {
      resetProgressbar()
      percentTime = 0
      tick = setInterval(interval, 10)
    }

    function interval() {
      if (($('.slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr('aria-hidden')) === 'true') {
        progressBarIndex = $('.slider .slick-track div[aria-hidden="false"]').data('slickIndex')
        startProgressbar()
      } else {
        percentTime += 1 / (time + 5)
        $('.inProgress' + progressBarIndex).css({
          width: percentTime + '%'
        })
        if (percentTime >= 100) {
          $('.single-item').slick('slickNext')
          progressBarIndex++
          if (progressBarIndex > 2) {
            progressBarIndex = 0
          }
          startProgressbar()
        }
      }
    }

    function resetProgressbar() {
      $('.inProgress').css({
        width: 0 + '%'
      })
      clearInterval(tick)
    }
    startProgressbar()
    // End ticking machine

    $('.item').on('click', function() {
      clearInterval(tick)
      var goToThisIndex = $(this).find('span').data('slickIndex')
      $('.single-item').slick('slickGoTo', goToThisIndex, false)
      startProgressbar()
    })
  }

  // smooth scroll-to on FAQ page
  $('[data-scroll-to]').on('click', function() {
    var element = $(this).attr('data-scroll-to'),
      headerOffset = 120,
      bodyScrollPos = document.querySelector('body').scrollTop,
      scrollSpeed = 500

    $('html, body').animate({
      scrollTop: $(element).offset().top + bodyScrollPos - headerOffset
    }, scrollSpeed)
  })

  // sign up form validation
  $('#home-form-container form').validate({
    rules: {
      'signup[email]': {
        required: true,
        email: true
      },
      'participants[email]': {
        email: true
      }
    },
    messages: {
      'signup[email]': {
        required: 'Please enter a valid email.',
      },
      'participants[email]': {
        required: 'Please enter a valid email.',
      }
    },
    errorElement: 'div',
    errorPlacement: function (error, element) {
      const formErrors = $('#home-form-container form #form-errors')
      formErrors.empty().append(error)
    },
    highlight: function (element) {
      $(element).addClass('is-invalid').removeClass('is-valid')
    },
    unhighlight: function (element) {
      $(element).addClass('is-valid').removeClass('is-invalid')
    }
  })

  // focus first input on page load - commented out to prevent page from scrolling on load
  // $('#home-form-container .signup_email input').trigger('focus')

}

// handle enter keypress on signup form
$(document).on('keypress', '#home-form-container input',function(e) {
  if (e.which == 13) {
    const currentEl = $('#home-form-container input:focus')

    if (currentEl.val() !== '' && currentEl.valid()) {
      currentEl.parent().addClass('form-group-valid')

      if ($('#email_list .signup_participants').length < 6) {
        $('.page, main').height($('.page').height() + 50)

        $('.overlay-section').animate({
            top: "+=50",
          },200,
          'linear',
          function() {
            handleFormUpdate(currentEl)
            adjustPageHeight()
          })
      } else {
        // submit the form
        $('#home-form-container form').trigger('submit')
        return
      }
    }
    // cancels form submit on 'enter'
    return false
  }
})

// adjust page height/footer position on resize
$(window).on('resize', debounce(adjustPageHeight, 100))

document.addEventListener('click', function (e) {
  // handle product tour video playback
  if (e.target.classList.contains('play-product-tour')) {
    var video = document.getElementById('product-tour-video')
    var container = document.querySelector('.product-tour-container')
    container.classList.add('active')
    video.play()
    setTimeout( () => {
      container.removeChild(e.target)
    }, 200)
  }

  // handle dropdowns on downloads page
  if (e.target.classList.contains('dropdown-trigger')) {
    e.preventDefault()
    e.target.classList.toggle('dropdown-open')
  } else {
    if (document.querySelector('.dropdown-trigger') != null) {
      document
        .querySelectorAll('.dropdown-trigger')
        .forEach(function (dropdown) {
          dropdown.classList.remove('dropdown-open')
        })
    }
  }
})

$(document).on('turbolinks:load', ready)
